import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IncotermsComponent} from '../incoterms.component'
//Services
import {IncotermService} from 'src/app/core/services/parameters/incoterm.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarIncotermModal implements OnInit {

  editIncotermForm: FormGroup;
  loading = false;
  showAlert = false;
  incotermId;
  incotermData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<IncotermsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private incotermService: IncotermService
  ) {
  }

  ngOnInit(): void {
    this.editIncotermForm = this.fb.group({
      description: [, Validators.required],
      incoterm: [, Validators.required]
    })
    this.incotermId = this.data.id;
    this.incotermService.getIncotermById(this.incotermId).subscribe(_res => {
      this.incotermData = _res;
      this.editIncotermForm.patchValue({
        description: _res.description,
        incoterm: _res.name
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editIncotermForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editIncotermForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.incoterm,
        description: form.value.description,
      }
      this.incotermService.updateIncoterm(this.incotermId, data).subscribe(_res => {
        this.alert.setNotice('Incoterm actualizado correctamente', 'success');
        this.showAlert = true;
            this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo actualizar el incoterm', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
